import React from 'react';
import Input from '../../mweb/Input/Input';
import Button from '../../common/Button/Button';
import { Link } from 'react-router-dom';
import './blog.scss';
import Icon from '../../mweb/Icon/Icon';
import { subscribeNewUser } from 'hb-redux-store/feature/checkout/checkout.action';
import { getDeviceType } from '../../../hb-redux-store/util/DeviceDetectionService';
import { DEVICE_TYPE } from '../../../hb-redux-store/util/constantServices';
import { connect } from 'react-redux';
import { isValidEmail } from '../../../hb-redux-store/util/miscellaneousServices';
import { setAppNotification } from 'hb-redux-store/initial.action';

const BlogNav = props => {
  // console.log('BlogNav: ', props);
  const logoAltTxt =
    'Get Grade A quality Fruits, Nuts, Vegetables | Early Morning Delivery | VegXL';
  const [email, setEmail] = React.useState('');
  const [emailErrorMsg, setEmailErrorMsg] = React.useState('');
  const isDesktop = getDeviceType() === DEVICE_TYPE.DESKTOP;
  const subscribeToOffers = () => {
    if (!email.length || !isValidEmail(email)) {
      setEmailErrorMsg('Please enter valid email Id. ');
      return;
    }
    const data = {
      accountEmail: email,
      subscriptionType: 'dealsAndOffers',
    };
    const cb = () =>
      props.setAppNotification(
        'Subscribed! You will be receiving latest updates from VegXL. Stay tuned!'
      );
    props.subscribeNewUser(data, cb);
    setEmailErrorMsg('');
  };
  return (
    <div className="desktop-blog-nav">
      <div className="desktop-blog-nav--container">
        <div className="justify-content--space-between">
          <Link to="/">
            <img
              className="desktop-blog-nav--logo"
              alt={logoAltTxt}
              src={require('../../../assets/icons/icon-halalbox-navbar.svg')}
            />
          </Link>
          <Input
            type="text"
            name="email"
            className="full-width"
            hasError={!!emailErrorMsg}
            errorMsg={emailErrorMsg}
            suffix={
              isDesktop ? (
                <Button
                  className="button action-link subscribe-cta desktop-address-card--edit-action"
                  onClick={subscribeToOffers}
                >
                  SUBSCRIBE
                </Button>
              ) : (
                <Icon
                  class="icon-back-bar-back right-arrow action-arrow"
                  size={15}
                  onClick={subscribeToOffers}
                />
              )
            }
            onChange={({ email }) => setEmail(email)}
            placeholder="Enter your email id here"
            value={email}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = null;
const mapDispatchToProps = {
  subscribeNewUser,
  setAppNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(BlogNav);
